import React, { useEffect, useState } from 'react'
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { GrFormClose } from 'react-icons/gr';

const OutStandingPosition = (props) => {
    console.log("props?.dataKey ==>", props?.dataKey);
    
    const headerText = props?.dataKey?.length > 0 ? props.t('bet_detail') : props.t('betting_position')
    return (
        <div className="outstanding-bet">
            <span className="close" onClick={props.handle} ><GrFormClose /></span>
            <div className="outstanding-bet-main">
                <h5>{headerText}</h5>
                <div className='turn-popup-table-details'>
                    <div className='turn-popup-table p-2'>
                        <div className='da-ms'>
                            {props.data}
                        </div>
                        <div>
                            {props?.dataKey?.length > 0 && (
                                <div className='tm-data'>
                                    {props?.dataKey.map((item, ind) => (
                                        <div className='row-mn'>
                                            <span className='mn-l'>{props.t(item)}</span>
                                            <span className="ms-a" key={ind}>
                                                {props.mobileData?.[item]}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

OutStandingPosition.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};
export default withTranslation()(OutStandingPosition)